import EditIcon from "@mui/icons-material/Edit";

import React from "react";
import { ColumnContainer } from "utils/columnsStyle";
import { useDispatch } from "react-redux";

import { COLLECT_PERIODS_CONFIG, COLLECT_PERIODS_PHRASE } from "./config";
import { editCollectPeriod } from "redux/actions/buildings/collectPeriods/collectPeriodsActions";

import RegularButton from "components/CustomButtons/Button";

const style = {
  color: "#004F9F",
  fontSize: 20,
  marginRight: 10,
  cursor: "pointer"
};

export const columns = [
  {
    Header: () => <span>{COLLECT_PERIODS_CONFIG.name.label}</span>,
    accessor: COLLECT_PERIODS_CONFIG.name.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[COLLECT_PERIODS_CONFIG.name.key]
        ? row[COLLECT_PERIODS_CONFIG.name.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{COLLECT_PERIODS_CONFIG.type.label}</span>,
    accessor: COLLECT_PERIODS_CONFIG.type.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[COLLECT_PERIODS_CONFIG.type.key]
        ? row[COLLECT_PERIODS_CONFIG.type.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{COLLECT_PERIODS_CONFIG.cutDay.label}</span>,
    accessor: COLLECT_PERIODS_CONFIG.cutDay.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[COLLECT_PERIODS_CONFIG.cutDay.key]
        ? row[COLLECT_PERIODS_CONFIG.cutDay.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },

  {
    Header: () => <span>{COLLECT_PERIODS_CONFIG.payDay.label}</span>,
    accessor: COLLECT_PERIODS_CONFIG.payDay.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[COLLECT_PERIODS_CONFIG.payDay.key]
        ? row[COLLECT_PERIODS_CONFIG.payDay.key]
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : "",
  },

  {
    Header: () => <span>Acciones</span>,
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const openEdit = () => {
        original.modal();
        dispatch(editCollectPeriod(original));
      };
      return (
        <ColumnContainer>
          <RegularButton
            color="transparent"
            round
            justIcon
            tooltip={COLLECT_PERIODS_PHRASE.modal.actions.edit}
            onClick={openEdit}
            size="sm"
          >
            <EditIcon style={style} />
          </RegularButton>
        </ColumnContainer>
      );
    },
  },
];
